module.exports = __webpack_public_path__ + "img/down.3409f8b9.svg";